exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#smVipPrivacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#smVipPrivacy div {\n  margin: 0.1rem 0;\n}\n#smVipPrivacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#smVipPrivacy div a {\n  color: #000;\n}\n#smVipPrivacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b4c1649a","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/module/sm_vip_privacy_en/sm_vip_privacy_en.vue
// module id = 373
// module chunks = 15